import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { setFilters } from '../contactsSlice'
import { selectContactsFilters } from '../selectors/selectContactsFilters'

interface IParams {
  /** `null`: every offering. */
  programType: ProgramTypes | null
  partnerId: string
}

export const useContactsFilters = ({ programType, partnerId }: IParams) => {
  const dispatch = useDispatch()
  const { partnerId: statePartnerId, programType: stateProgramType } =
    useSelector(selectContactsFilters)

  useEffect(() => {
    dispatch(setFilters({ partnerId, programType }))
  }, [dispatch, partnerId, programType])

  return {
    partnerId: statePartnerId,
    programType: stateProgramType,
  }
}
